/**
 * 👑 A CAMADA PLATAFORMA TEM UMA CARA — decisão 1 do R2 (26/08/2026).
 *
 * Em rota do Operador (`/operador/*`, `/manual-de-bordo`) a pele é SEMPRE v2
 * com a marca da casa; fora dela, volta a ser a do tenant ativo. A regra mora
 * em `aplicarPeleDaRota` (lib/skin) — este gancho só a liga ao roteador, pra
 * navegação SPA (que não recarrega e portanto não re-roda o boot).
 *
 * Chamado pelo Layout, que renderiza em toda página logada.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { aplicarPeleDaRota } from "../lib/skin";

export function usePeleDaRota(): void {
  const { pathname } = useLocation();
  useEffect(() => {
    aplicarPeleDaRota(pathname);
  }, [pathname]);
}
